import { render } from "./Alertas.vue?vue&type=template&id=d544e1e6"
import script from "./Alertas.vue?vue&type=script&lang=js"
export * from "./Alertas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__